module.exports = {"news":{"read":"Подробнее"}};